{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "すべてのオプションを見る",
  "Spoiler_Reveal_Tooltip": "クリックして表示",
  "VerticalEmbed_Event_Error_Subtitle": "このイベントは削除されました。別のイベントと置き換えてください。",
  "Viewer_Toolbar_Twitter_Tooltip": "ツイートする",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "アイテムが折りたたまれました",
  "Spoiler_Reveal_Video_CTA": "ぼかしを外す",
  "VerticalEmbed_Pricing_Plan": "プランのみ",
  "Image_Expand_Button_AriaLabel": "画像を拡大",
  "VerticalEmbed_From_Price": "最小価格",
  "Poll_Viewer_ShowAllResults_CTA": "すべての結果を表示",
  "Spoiler_Reveal_Image_Placeholder": "この画像にはぼかしが入っています",
  "VerticalEmbed_Ribbon": "セール",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "シークバー",
  "VerticalEmbed_Error_Subtitle": "このアイテムは削除されました。別のアイテムと置き換えてください。",
  "Poll_Viewer_Multiselect_Footer": "複数の回答に投票することができます。",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "その他のオーディオコントロールを表示",
  "VerticalEmbed_Booking_Fetch_Error_Title": "サービスが読み込まれませんでした",
  "Fullscreen_Close_Button_AriaLabel": "閉じる",
  "VerticalEmbed_Event_Fetch_Error_Title": "イベントが読み込まれませんでした",
  "UploadFile_Viewer_Loader": "読み込み中：{{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "ユーザーアバター",
  "Preview_ReadMore_Label": "続きを読む",
  "Spoiler_Insert_Tooltip": "ぼかし",
  "VerticalEmbed_Product_Fetch_Error_Title": "商品が読み込まれませんでした",
  "Fullscreen_Shrink_Button_AriaLabel": "縮小",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "検索数",
  "Spoiler_Reveal_Gallery_Placeholder": "このギャラリーにはぼかしが入っています",
  "Fullscreen_Expand_Button_AriaLabel": "展開",
  "VerticalEmbed_Bookings_Button": "今すぐ予約",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "ミュートを解除",
  "Spoiler_Reveal_Gallery_CTA": "ぼかしを外す",
  "Poll_Viewer_ShowLess_CTA": "折りたたむ",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "ミュート",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}}名 匿名ゲスト",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "フォロー",
  "VerticalEmbed_Products_Button": "購入する",
  "Poll_Viewer_Toast_Error_ServerDown": "サーバーに接続できませんでした。後ほどお試しください。",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}}人がこの回答に投票しました",
  "Poll_Viewer_VoteCount": "{{number}}件の投票",
  "VerticalEmbed_Events_Button": "今すぐ登録",
  "Spoiler_Reveal_Image_CTA": "ぼかしを外す",
  "Poll_Viewer_Toast_Error_Connection": "問題が発生しました。接続状況をご確認ください",
  "Poll_Viewer_Visibility_Owner_Footer": "自分だけが結果を見ることができます。",
  "VerticalEmbed_Booking_Error_Title": "サービスが削除されました",
  "VerticalEmbed_Product_Error_Title": "商品を削除しました",
  "VerticalEmbed_Fetch_Error_Subtitle": "アイテム情報が読み込まれませんでした。",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}}人がこの回答に投票しました",
  "VerticalEmbed_Event_Error_Title": "イベントが削除されました。",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "アイテムが展開されました",
  "Audio_Plugin_Cover_Alt": "音声カバー",
  "Spoiler_Reveal_Video_Placeholder": "この動画にはぼかしが入っています",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "技術的な問題が発生しました。お手数ですが、接続状況を確認して再度お試しください。",
  "VerticalEmbed_Fetch_Error_Title": "アイテムが読み込まれませんでした",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "この商品は削除されました。別の商品と置き換えてください。",
  "VerticalEmbed_Booking_Error_Subtitle": "このサービスは削除されました。別のサービスで置き換えてください。",
  "Preview_SeeFullPost_Label": "記事全文を表示",
  "UploadFile_Viewer_Download": "ダウンロード：{{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}}時間",
  "VerticalEmbed_Units_Minute": "{{minutes}}分",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "技術的な問題が発生しました。お手数ですが、接続状況を確認して再度お試しください。",
  "VerticalEmbed_Error_Button": "置き換え",
  "VerticalEmbed_Error_Title": "アイテムが削除されました",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "技術的な問題が発生しました。お手数ですが、接続状況を確認して再度お試しください。",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
